module.exports = __webpack_public_path__ + "c37897fd8bd59b2ca0669ddd295c9e58.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-s.png
// module id = 2169
// module chunks = 0